var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"value":_vm.value,"persistent":""}},[_c('div',{staticClass:"d-flex justify-center align-center"},[_c('v-progress-circular',{attrs:{"size":90,"width":8,"color":"kbWhite","indeterminate":""}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }